import { configureStore } from "@reduxjs/toolkit";
import { UserReducer, ForgetPasswordReducer,GenerateHastagReducer,GenerateCaptionReducer,GenerateContentReducer } from "./slice/index.js";


export default configureStore({
  reducer: {
    auth: UserReducer,
    GenerateHastag:GenerateHastagReducer,
    GenerateCaption:GenerateCaptionReducer,
    GenerateContent:GenerateContentReducer,
    resetPassword: ForgetPasswordReducer,
  },
});



